import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import TextInputField from "../components/TextInputField";
import { getKeyMaterial } from "../controllers/EncryptionController";

export default function Login() {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState({
    email: "",
    password: "",
  });
  const displayLoginFields = ["email", "password"];

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const handleError = (err) => {
    toast.error(err, {
      position: "bottom-left",
    });

    setInputValue({
      ...inputValue,
      email: "",
      password: "",
    });
  };

  const handleSuccess = (msg) =>
    toast.success(msg, {
      position: "bottom-left",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/login`,
        {
          ...inputValue,
        },
        { withCredentials: true }
      );
      const { success, message } = data;
      if (success) {
        const keyMaterial = await getKeyMaterial(inputValue.password);
        handleSuccess(message);
        setTimeout(() => {
          navigate("/credentials", { state: { key: keyMaterial } });
        }, 1000);
      } else {
        handleError(message);
      }
    } catch (error) {
      console.log(error);
      setInputValue({
        ...inputValue,
        email: "",
        password: "",
      });
    }
  };

  return (
    <div className="container" align="center">
      <h1 align="center">Login</h1>
      <ul>
        {displayLoginFields.map((key) => (
          <li key={key}>
            <TextInputField
              displayName={key}
              name={key}
              type={key}
              value={inputValue[key]}
              isEditable={true}
              nameValueInterPadding={1}
              onChange={handleOnChange}
              onKeyUp={(e) => {
                e.key === "Enter" && console.log(inputValue);
              }}
            />
          </li>
        ))}
      </ul>
      <button onClick={handleSubmit}>Submit</button>
      <br />
      <br />
      <span>
        Don't have an account? <Link to={"/signup"}>Signup</Link>
      </span>
      <ToastContainer />
    </div>
  );
}
